import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BASociologyCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Sociology",
    shortName: "B.A. Sociology",
    duration: "3 years",
    description: "Study of society, social relationships, and human behavior",
    overview: "Bachelor of Arts in Sociology is a 3-year undergraduate program that provides students with a comprehensive understanding of society, social institutions, and human behavior. This course covers social theory, research methods, social problems, and contemporary issues, preparing students for careers in social work, research, and community development.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Interest in social sciences and human behavior",
      "Good communication and analytical skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Introduction to Sociology",
          "Social Anthropology",
          "History of Sociological Thought",
          "General English",
          "Tamil Literature",
          "Economics (Optional)"
        ]
      },
      {
        year: 2,
        subjects: [
          "Social Research Methods",
          "Social Problems and Social Policy",
          "Urban and Rural Sociology",
          "Family and Kinship",
          "Political Sociology",
          "Indian Society and Culture"
        ]
      },
      {
        year: 3,
        subjects: [
          "Social Stratification",
          "Sociology of Development",
          "Gender Studies",
          "Criminology and Penology",
          "Environmental Sociology",
          "Project Work"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Social Worker",
        "Research Analyst",
        "Community Development Officer",
        "NGO Worker",
        "Social Researcher",
        "Human Rights Activist",
        "Policy Analyst",
        "Counselor",
        "Content Writer",
        "Civil Services Officer"
      ],
      industries: [
        "Social Work Organizations",
        "NGOs and NPOs",
        "Government Departments",
        "Research Institutes",
        "Media Organizations",
        "Educational Institutions",
        "Healthcare Sector",
        "Corporate CSR",
        "International Organizations",
        "Publishing Houses"
      ],
      averageSalary: "₹2.5-6 LPA (Fresher), ₹8-18 LPA (Experienced)",
      topRecruiters: [
        "UNDP, UNICEF, WHO",
        "Tata Trusts, Ford Foundation",
        "CRY, Teach for India",
        "Government Social Welfare Dept",
        "NABARD, SIDBI",
        "Media Houses"
      ]
    },

    admissionProcess: [
      "Merit-based admission on 12th marks",
      "Some colleges conduct entrance tests",
      "Interview process in select institutions",
      "Online application through college websites",
      "Document verification and counseling"
    ],

    topColleges: [
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹45,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "Madras Christian College",
        location: "Chennai",
        fees: "₹40,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Stella Maris College",
        location: "Chennai",
        fees: "₹42,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Bharathidasan University",
        location: "Tiruchirappalli",
        fees: "₹25,000",
        ranking: "State University"
      }
    ],

    skills: [
      "Social Research Methods",
      "Data Collection and Analysis",
      "Critical Thinking",
      "Communication Skills",
      "Report Writing",
      "Statistical Analysis",
      "Interview Techniques",
      "Group Discussion",
      "Problem-Solving",
      "Cultural Sensitivity"
    ],

    futureScope: "Growing opportunities in social research, policy making, community development, and corporate social responsibility with increasing focus on social issues and sustainable development.",

    faqs: [
      {
        question: "What career options are available after B.A. Sociology?",
        answer: "Graduates can pursue careers in social work, research, NGOs, government services, media, counseling, and further studies like M.A. Sociology or MBA."
      },
      {
        question: "Is sociology only theoretical or does it have practical applications?",
        answer: "Sociology has strong practical applications in social research, policy making, community development, and understanding social problems for effective solutions."
      },
      {
        question: "Can I pursue civil services after B.A. Sociology?",
        answer: "Yes, sociology is an excellent foundation for civil services with sociology as an optional subject in UPSC mains examination."
      },
      {
        question: "What are the higher education options?",
        answer: "Students can pursue M.A. Sociology, M.S.W., MBA, M.A. in related fields, or professional courses in counseling and social work."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BASociologyCoursePage;
